import { numberOrNull } from '@unreserved-frontend-v2/utils/numbers'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
  ResidentialType,
} from '@unreserved-frontend-v2/api/generated/graphql/types'

/**
 * Gets a breakdown of beds for either apartment or house
 * @returns An array of above & below beds (dens for apartment)
 */
export const bedsBreakdown = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
) => {
  let total: [number | null, number] = [null, 0]

  if (!details) {
    return total
  }

  if (details.residentialType === ResidentialType.Apartment) {
    const apartment = details as ResidentialApartmentPropertyDetails
    total = [numberOrNull(apartment.beds), apartment.dens || 0]
  } else {
    const house = details as ResidentialHousePropertyDetails
    total = [numberOrNull(house.bedsAboveGrade), house.bedsBelowGrade || 0]
  }

  return total
}
